import React from 'react';
import Navbar from './Navbar';

const Header = () => (
  <div className="header">
    <div className="logo">
      <h1>Math Magicians</h1>
    </div>
    <Navbar />
  </div>
);

export default Header;
